<div class="lum-modal client-profile-dialog__modal-wrapper">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large"
      >{{ isEdit ? 'Update' : 'Add New' }} Card</span
    >
    <small><i>We only accept Visa, Mastercard, Amex and Union pay</i></small>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="close"
        (click)="onClose()"
        aria-label="Close Credit Card Dialog"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="var(--col-cloud-600)"
          width="23"
          height="23"
        ></lum-ui-icon>
      </button>
    </div>
  </div>

  <form [formGroup]="form" class="invoice-note-form__wrapper" (submit)="onSubmit()">
    <div class="lum-modal__body mt-0">
      <mat-tab-group
        class="header-less-tabs"
        [selectedIndex]="currentTab"
        dynamicHeight
        #tabGroup
      >
        <mat-tab label="">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div class="lum-label">
                  Card Number
                  <i class="font-semi-bold" *ngIf="cardType"
                    >[{{ cardType.toUpperCase() }}]</i
                  >
                </div>
                <input
                  cdkFocusInitial
                  formControlName="number"
                  class="lum-input"
                  type="tel"
                  placeholder="•••• •••• •••• ••••"
                  matInput
                  ccNumber
                />
                <mat-error *ngIf="numberControl && numberControl.invalid">{{
                  numberControl | validateField
                }}</mat-error>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <div class="lum-label">Expiry</div>
                <input
                  formControlName="expirationDate"
                  class="lum-input"
                  type="tel"
                  placeholder="•• / ••"
                  matInput
                  ccExp
                />
                <mat-error
                  *ngIf="expirationDateControl && expirationDateControl.invalid"
                  >{{ expirationDateControl | validateField }}</mat-error
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <div class="lum-label">CVV</div>
                <input
                  formControlName="cvv"
                  class="lum-input"
                  placeholder="•••"
                  matInput
                />
                <mat-error *ngIf="cvvControl && cvvControl.invalid">{{
                  cvvControl | validateField
                }}</mat-error>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div class="lum-label">Label</div>
                <input
                  formControlName="label"
                  class="lum-input"
                  type="text"
                  matInput
                />
                <mat-error *ngIf="labelControl && labelControl.invalid">{{
                  labelControl | validateField
                }}</mat-error>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="">
          <ng-container *ngIf="isEdit">
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card-profile--container flex align-items-center px-2 mb-4"
                >
                  <div class="flex align-items-center gap-6">
                    <div class="icon-wrapper w-20">
                      <img class="card-img" src="/assets/images/card.png" alt="" />
                    </div>
                    <div class="card-number-details flex flex-column">
                      <div class="card-label flex flex-column">
                        <span>{{ card.label }}</span>
                        <span class="font-semi-bold">{{
                          card.lastFourDigits | maskCardNumber
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="card-expiry flex mx-auto">
                    <span>{{ card | formatCardExpiry }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <div class="lum-label">Label</div>
                  <input
                    formControlName="label"
                    class="lum-input"
                    type="text"
                    matInput
                  />
                  <mat-error *ngIf="labelControl && labelControl.invalid">{{
                    labelControl | validateField
                  }}</mat-error>
                </div>
              </div>
            </div>
          </ng-container>
          <div *ngIf="!isEdit" class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div class="lum-label">Select Contact</div>
                <mat-select
                  class="lum-select w-100"
                  formControlName="clientContactId"
                  (selectionChange)="onSelectContact($event)"
                >
                  <mat-option
                    *ngFor="let contact of contacts; trackBy: trackById"
                    [value]="contact.id"
                    >{{ contact?.userAccount?.fullName }} [{{
                      contact?.userAccount?.email
                    }}]</mat-option
                  >
                </mat-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <div class="lum-label">First Name</div>
                <input
                  formControlName="firstName"
                  class="lum-input"
                  type="text"
                  matInput
                />
                <mat-error *ngIf="firstNameControl && firstNameControl.invalid">{{
                  firstNameControl | validateField
                }}</mat-error>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <div class="lum-label">Last Name</div>
                <input
                  formControlName="lastName"
                  class="lum-input"
                  type="text"
                  matInput
                />
                <mat-error *ngIf="lastNameControl && lastNameControl.invalid">{{
                  lastNameControl | validateField
                }}</mat-error>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div class="lum-label">Address</div>
                <input
                  formControlName="address"
                  class="lum-input"
                  type="text"
                  matInput
                />
                <mat-error *ngIf="addressControl && addressControl.invalid">{{
                  addressControl | validateField
                }}</mat-error>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <div class="lum-label">Countries</div>
                <mat-select class="lum-select" formControlName="country">
                  <mat-option
                    *ngFor="let country of countries; trackBy: trackById"
                    [value]="country.id"
                  >
                    {{ country.label }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="countryControl && countryControl.invalid">{{
                  countryControl | validateField
                }}</mat-error>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <div class="lum-label">Zip</div>
                <input
                  formControlName="zip"
                  class="lum-input"
                  type="text"
                  matInput
                />
                <mat-error *ngIf="zipControl && zipControl.invalid">{{
                  zipControl | validateField
                }}</mat-error>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <div class="lum-label">City</div>
                <input
                  formControlName="city"
                  class="lum-input"
                  type="text"
                  matInput
                />
                <mat-error *ngIf="cityControl && cityControl.invalid">{{
                  cityControl | validateField
                }}</mat-error>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <div class="lum-label">State</div>
                <mat-select class="lum-select" formControlName="state">
                  <mat-option
                    *ngFor="let state of states; trackBy: trackById"
                    [value]="state.id"
                  >
                    {{ state.label }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="stateControl && stateControl.invalid">{{
                  stateControl | validateField
                }}</mat-error>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="lum-modal__footer">
      <div class="flex ml-auto lum-modal__action">
        <ng-container *ngIf="currentTab === 0; else submit">
          <button
            type="button"
            class="lum-button lum-button--secondary mr-2"
            mat-button
            (click)="onClose()"
          >
            Discard
          </button>
          <button
            mat-button
            type="submit"
            class="lum-button"
            [disabled]="hasInvalidCardInput"
            (click)="onChangeTab(tabGroup, 1)"
          >
            Next
          </button>
        </ng-container>
        <ng-template #submit>
          <button
            *ngIf="!isEdit"
            type="button"
            class="lum-button lum-button--secondary mr-2"
            mat-button
            (click)="onChangeTab(tabGroup, 0)"
          >
            Back
          </button>
          <button
            *ngIf="isEdit"
            type="button"
            class="lum-button lum-button--secondary mr-2"
            mat-button
            (click)="onClose()"
          >
            Discard
          </button>

          <button
            mat-button
            type="submit"
            class="lum-button"
            [disabled]="hasInvalidCardProfileInput || loading"
          >
            <span class="d-flex align-items-center">
              {{ isEdit ? 'Update Label' : 'Create' }}
              <mat-spinner
                class="inline-block ml-1"
                [diameter]="16"
                *ngIf="loading || false"
              ></mat-spinner>
            </span>
          </button>
        </ng-template>
      </div>
    </div>
  </form>
</div>
